export var MOBILE_MIN_WIDTH = 320;
export var TABLET_MIN_WIDTH = 768;
export var DESKTOP_MIN_WIDTH = 1025;


//////////////////
// WEBPACK FOOTER
// ../es/constants/media.js
// module id = 6qs0
// module chunks = 73